.container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 16px;
}

.field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 4px 8px;
    background: var(--off-white);
    border-radius: 4px;
}
